/**
 * src/components/footer/FooterLinks.js
 *
 * Columna de enlaces del footer. Componente reutilizable.
 * Props: { title, links: Array<{ label, href }> }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'

define('FooterLinks', ({ title, links = [] }) => {
    const items = links.map(({ label, href }) =>
        h('li', { className: 'footer-links__item' },
            h('a', { className: 'footer-links__anchor', href }, label)
        )
    )

    return h('div', { className: 'footer-links' },
        h('h4', { className: 'footer-links__title' }, title),
        h('ul', { className: 'footer-links__list' }, ...items)
    )
})
